export const SellerValidationFailedReasonType = {
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
    /** 배송지를 선택하세요 */
    BLANK_DELIVERY_ADDRESS_GIFTING: 'BLANK_DELIVERY_ADDRESS_GIFTING',
    /** 정확한 배송을 위해 배송지를 한글명으로 변경해주세요. */
    NOT_INCLUDED_KOREAN_IN_BASE_ADDRESS: 'NOT_INCLUDED_KOREAN_IN_BASE_ADDRESS',
    /** 선택한 주소는 N배송 상품 정보를 확인할 수 없습니다. 도로명 주소로 다시 입력해주세요. */
    REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT:
        'REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT',
    /** 수령위치를 선택해주세요. */
    INVALID_PICKUP_LOCATION_TYPE: 'INVALID_PICKUP_LOCATION_TYPE',
    /** 출입방법을 선택해주세요. */
    INVALID_ENTRY_METHOD_TYPE: 'INVALID_ENTRY_METHOD_TYPE',
    /** 문 앞까지 배송해드리기 위해 공동현관 비밀번호를 입력해주세요. */
    INVALID_LOBBY_PW_ENTRY_METHOD_CONTENT: 'INVALID_LOBBY_PW_ENTRY_METHOD_CONTENT',
    /** 문 앞까지 배송해드리기 위해 기타 출입방법을 입력해주세요. */
    INVALID_OTHER_ENTRY_METHOD_CONTENT: 'INVALID_OTHER_ENTRY_METHOD_CONTENT',
    /** 최대 50자까지 입력할 수 있습니다. */
    INVALID_ENTRY_METHOD_CONTENT_SIZE: 'INVALID_ENTRY_METHOD_CONTENT_SIZE',
    /** 원하시는 위치에 배송해드리기 위해 기타 수령위치를 입력해주세요. */
    INVALID_PICKUP_LOCATION_CONTENT: 'INVALID_PICKUP_LOCATION_CONTENT',
    /** 최대 50자까지 입력할 수 있습니다. */
    INVALID_PICKUP_LOCATION_CONTENT_SIZE: 'INVALID_PICKUP_LOCATION_CONTENT_SIZE',
    INVALID_SELECTED_PRODUCT_DISCOUNT: 'INVALID_SELECTED_PRODUCT_DISCOUNT',
    INVALID_SELECTED_IMMEDIATE_DISCOUNT: 'INVALID_SELECTED_IMMEDIATE_DISCOUNT',
    DUPLICATED_SELECTED_STORE_COUPON: 'DUPLICATED_SELECTED_STORE_COUPON',
    /** 사용할 수 없는 쿠폰이 있습니다. 주문서를 새로고침 하거나 다시 진입해주세요. */
    INVALID_SELECTED_STORE_COUPON: 'INVALID_SELECTED_STORE_COUPON',

    // Checker 오류
    /** 1회 최대 구매 가능 건수(100개)를 초과하여 주문이 불가능합니다. */
    TOTAL_PURCHASE_LIMIT: 'TOTAL_PURCHASE_LIMIT',
    /** 상품금액이 변경되었습니다. 상품상세에서 다시 구매해주세요. */
    PRODUCT_PRICE: 'PRODUCT_PRICE',
    /** 재고부족으로 인한 판매불가 상품입니다. */
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    /** 현재 판매되지 않는 상품입니다. */
    PRODUCT_STATUS: 'PRODUCT_STATUS',
    /** 공동구매 정보 변경 */
    PRODUCT_GROUP_BUYING_INFO: 'PRODUCT_GROUP_BUYING_INFO',
    /** 장바구니에 담으시려는 수량보다 상품 재고 수량이 부족합니다. */
    PRODUCT_STOCK_QUANTITY: 'PRODUCT_STOCK_QUANTITY',
    /** 상품정보가 변경되어 장바구니에 담을 수 없습니다. */
    PRODUCT_TYPE: 'PRODUCT_TYPE',
    /** 상품명이 없습니다. */
    PRODUCT_NAME_EMPTY: 'PRODUCT_NAME_EMPTY',
    /** 19세 미만은 구매가 불가능한 상품입니다. */
    ADULT_ONLY_PURCHASE: 'ADULT_ONLY_PURCHASE',
    /** 장바구니 구매를 할 수 없는 상품이 있습니다. */
    CART_RESTRICT: 'CART_RESTRICT',
    /** 스토어찜 회원만 구매 가능한 상품이 있습니다. */
    SUBSCRIPTION: 'SUBSCRIPTION',
    // 일반 ReasonType에도 존재하지만 상품 검증 오류 메시지가 달라 중복으로 존재
    /** 회원님은 해당 판매자의 상품 구매가 불가 합니다.\n자세한 사항은 상품 Q&A를 통해 판매자에게 문의하여 주시기 바랍니다. */
    BLACK_CONSUMER: 'BLACK_CONSUMER',
    /**
     * @deprecated 재구매 시 기존주문의 OrderErrorCode를 맞춰주기 위해 사용됩니다.
     * 재구매를 위한 새로운 FE 페이지를 만들어 거기서 BLACK_CONSUMER 코드를 사용하고: "사용하고,
     * 기존주문에서는 더 이상 사용하지 않으면 삭제할 수 있습니다.
     */
    /** 판매자에 의해 제한된 회원입니다. */
    BLACKCONSUMER: 'BLACKCONSUMER',
    /** 장보기 지점혜택 정보가 변경된 상품이 있습니다. */
    BRANCH_BENEFIT: 'BRANCH_BENEFIT',
    /** 선택하신 배송시간의 주문이 마감되어 결제가 불가합니다. 다른 날짜/시간으로 선택하여 주문해주세요. */
    INVALID_BRANCH_DELIVERY: 'INVALID_BRANCH_DELIVERY',
    /** 현재 운영시간이 마감되어 결제가 불가능합니다. 운영시간에 다시 주문해주세요. */
    INVALID_BRANCH_IMMEDIATE_DELIVERY: 'INVALID_BRANCH_IMMEDIATE_DELIVERY',
    DELIVERY_METHOD: 'DELIVERY_METHOD',
    /** 배송희망일 상품정보가 변경되었습니다. */
    HOPE_DELIVERY_DATE_REJECT: 'HOPE_DELIVERY_DATE_REJECT',
    /** 배송희망일을 선택해주세요. */
    HOPE_DELIVERY_DATE_NEED: 'HOPE_DELIVERY_DATE_NEED',
    /** 배송희망일이 유효하지 않습니다. */
    HOPE_DELIVERY_DATE_STATUS: 'HOPE_DELIVERY_DATE_STATUS',
    /** 옵션정보가 변경되어 장바구니에 담을 수 없습니다. */
    OPTION_INFO: 'OPTION_INFO',
    /** 표준구매옵션 변경 */
    STANDARD_GROUP_PRODUCT: 'STANDARD_GROUP_PRODUCT',
    /** 상품금액이 변경되었습니다. 상품상세에서 다시 구매해주세요. */
    OPTION_PRICE: 'OPTION_PRICE',
    /** 현재 판매되지 않는 상품 옵션입니다. */
    OPTION_STATUS: 'OPTION_STATUS',
    /** 장바구니에 담으시려는 수량보다 상품 재고 수량이 부족합니다. */
    OPTION_STOCK_QUANTITY: 'OPTION_STOCK_QUANTITY',
    /** 옵션 재고가 부족하여 결제가 불가합니다. */
    OPTION_OUT_OF_STOCK: 'OPTION_OUT_OF_STOCK',
    /** 옵션정보가 변경되어 장바구니에 담을 수 없습니다. */
    SUPPLEMENT_INFO: 'SUPPLEMENT_INFO',
    /** 추가상품 금액이 변경되었습니다. 상품상세에서 다시 구매해주세요. */
    SUPPLEMENT_PRICE: 'SUPPLEMENT_PRICE',
    /** 현재 판매되지 않는 추가 상품입니다. */
    SUPPLEMENT_STATUS: 'SUPPLEMENT_STATUS',
    /** 장바구니에 담으시려는 수량보다 추가상품 재고 수량이 부족합니다. */
    SUPPLEMENT_STOCK_QUANTITY: 'SUPPLEMENT_STOCK_QUANTITY',
    ITEM_NOT_FOUND: 'ITEM_NOT_FOUND', // TODO: 제거 예정
    /** 즉시할인 금액이 변경되었습니다. */
    IMMEDIATE_DISCOUNT: 'IMMEDIATE_DISCOUNT',
    /** 특수할인 금액이 변경되었습니다. */
    SPECIAL_DISCOUNT: 'SPECIAL_DISCOUNT',
    /** 복수구매 할인의 정보가 변경되었습니다. */
    MULTI_DISCOUNT: 'MULTI_DISCOUNT',
    /** 가격 이상/재고 부족으로 인해 상품 구매가 불가합니다. */
    REALTIME_PRODUCT_INFO: 'REALTIME_PRODUCT_INFO',
    /** 실시간 상품 할인 금액을 확인할 수 없습니다. */
    REALTIME_PRODUCT_INFO_DISCOUNT_AMOUNT: 'REALTIME_PRODUCT_INFO_DISCOUNT_AMOUNT',
    /** 구매가 불가능한 상품입니다. */
    REALTIME_PRODUCT_INFO_STATUS: 'REALTIME_PRODUCT_INFO_STATUS',
    /** 상품의 재고가 부족합니다. */
    REALTIME_PRODUCT_INFO_QUANTITY: 'REALTIME_PRODUCT_INFO_QUANTITY',
    /** 상품의 가격 정보가 변경되었습니다. */
    REALTIME_PRODUCT_INFO_PRICE: 'REALTIME_PRODUCT_INFO_PRICE',
    /** 존재하지 않는 상품입니다. */
    REALTIME_PRODUCT_INFO_FOUND: 'REALTIME_PRODUCT_INFO_FOUND',
    /** 재고 검사 중 오류가 발생했습니다. */
    REALTIME_PRODUCT_INFO_ERROR: 'REALTIME_PRODUCT_INFO_ERROR',
    /** 최대 무게/용량을 초과했습니다. */
    REALTIME_PRODUCT_INFO_EXCESS_CAPACITY: 'REALTIME_PRODUCT_INFO_EXCESS_CAPACITY',
    REALTIME_PRODUCT_INFO_DISCOUNT_AMT: 'REALTIME_PRODUCT_INFO_DISCOUNT_AMT',
    /** 상품정보가 변경되어 구매가 불가능합니다. 새로고침 후 다시 시도해주세요. */
    DELIVERY_ATTRIBUTE_CHANGE: 'DELIVERY_ATTRIBUTE_CHANGE',
    /** 도착보장 서비스가 불가능한 지역입니다. */
    FAIL_ADDRESS: 'FAIL_ADDRESS',
    /** 해당 네이버 도착보장 상품은 여러 옵션을 한번에 구매할 수 없습니다. 한 개의 옵션만 다시 선택해주세요. */
    FAIL_DELIVERY_BUNDLE: 'FAIL_DELIVERY_BUNDLE',
    /** 구매 불가 상품 */
    FAIL_ERROR: 'FAIL_ERROR',
    /** 구매 불가 상품 */
    FAIL_DELIVERY_PLAN: 'FAIL_DELIVERY_PLAN',
    /** 상품의 출고지 주소가 없습니다. */
    PRODUCT_TAKING_GOODS_PLACE: 'PRODUCT_TAKING_GOODS_PLACE',
    /** 오늘출발 가능수량이 부족합니다. */
    TODAY_DISPATCH_STOCK_QUANTITY: 'TODAY_DISPATCH_STOCK_QUANTITY',
    /** 예약구매 상품정보가 변경되었습니다. 상품정보를 다시 확인해주세요. */
    PRE_ORDER_REJECT: 'PRE_ORDER_REJECT',

    ORDER_SHEET_NOT_FOUND: 'ORDER_SHEET_NOT_FOUND',
    /** 1회 최대 구매 가능한 수량을 초과하였습니다. 장바구니에 담겨있는 상품 수량까지 확인해주세요. */
    MAX_PURCHASE_QUANTITY: 'MAX_PURCHASE_QUANTITY',
    /** 1회 최소 구매 가능한 수량 미만입니다. */
    MIN_PURCHASE_QUANTITY: 'MIN_PURCHASE_QUANTITY',
    /** 해당 채널 상품은 구매하실 수 없습니다. */
    CHANNEL_STATUS: 'CHANNEL_STATUS',
    /** 이 상품의 최대 구매수량을 이미 구매하셨으므로 더 이상 구매하실 수 없습니다. */
    EXHAUSTED_USER_PURCHASE_QUANTITY: 'EXHAUSTED_USER_PURCHASE_QUANTITY',
    /** 1인당 최대 구매수량을 초과하였습니다. 장바구니에 담겨있는 상품 수량까지 확인해주세요 */
    EXCESS_USER_PURCHASE_QUANTITY: 'EXCESS_USER_PURCHASE_QUANTITY',
    INVALID_GIFTING: 'INVALID_GIFTING',
    /** 선물 수신자를 확인할 수 없습니다. 다시 시도해주세요. */
    INVALID_GIFTING_RECEIVER: 'INVALID_GIFTING_RECEIVER',
    /** 해당 상품의 선물 속성이 올바르지 않아 선물을 할 수 없습니다. */
    INVALID_GIFTING_E_COUPON_AND_DELIVERY_METHOD_TYPE: 'INVALID_GIFTING_E_COUPON_AND_DELIVERY_METHOD_TYPE',
    INVALID_MAKE_ORDER_ARRIVAL_GUARANTEE: 'INVALID_MAKE_ORDER_ARRIVAL_GUARANTEE',
    /** 선물하기 구매개수를 초과하였습니다. */
    EXCEED_MAXIMUM_GIFTING_PRODUCT_ORDER_COUNT: 'EXCEED_MAXIMUM_GIFTING_PRODUCT_ORDER_COUNT',
    /** 선물받는 친구 수 데이터가 올바르지 않아 선물을 할 수 없습니다. \n다시 주문하여 주세요. */
    NOT_MATCHED_FRIENDS_COUNT: 'NOT_MATCHED_FRIENDS_COUNT',
    /** 선물하기 구매개수를 초과하였습니다. */
    EXCEED_MAXIMUM_FRIENDS_COUNT: 'EXCEED_MAXIMUM_FRIENDS_COUNT',
    /** 선물받는 친구 수 데이터가 올바르지 않아 선물을 할 수 없습니다. */
    EXCEED_AVAILABLE_FRIENDS_COUNT: 'EXCEED_AVAILABLE_FRIENDS_COUNT',
    /** 해당 상품의 선물 속성이 올바르지 않아 선물을 할 수 없습니다. */
    INVALID_GIFTING_DELIVERY: 'INVALID_GIFTING_DELIVERY',
    /** 현재 알비백 보증금 금액 조회 오류로 주문이 불가합니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_RBBAG_DEPOSIT: 'FAILED_GET_RBBAG_DEPOSIT',
    /** 알비백 보증금 금액이 변경되어 다시 주문 부탁드립니다. */
    INVALID_RBBAG_DEPOSIT: 'INVALID_RBBAG_DEPOSIT',
    /** 최대할부기간을 초과할 수 없습니다 */
    INSTALLMENT_MONTH_LIMIT_EXCEEDED: 'INSTALLMENT_MONTH_LIMIT_EXCEEDED',

    /** 서비스 문제로 현재 구매가 불가합니다. 잠시 후 다시 시도해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_API: 'FAILED_CHECK_PRODUCT_STOCK_API',
    /** 현재 재고 조회 오류로 결제가 불가합니다. 잠시 후 다시 주문해주세요. */
    FAILED_CHECK_PRODUCT_STOCK: 'FAILED_CHECK_PRODUCT_STOCK',
    /** 할인정보가 변경되어 결제가 불가합니다. */
    FAILED_CHECK_PRODUCT_STOCK_MERCHANT_IMMEDIATE_DISCOUNT: 'FAILED_CHECK_PRODUCT_STOCK_MERCHANT_IMMEDIATE_DISCOUNT',
    /** 선택한 주소는 네이버도착보장 상품의 구매가 불가능한 주소입니다. 다른 주소를 선택해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ADDRESS: 'FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ADDRESS',
    /** 상품의 배송정보가 변경되었습니다. 상품을 다시 확인하시고 구매해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ATTRIBUTE: 'FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ATTRIBUTE',
    /** 상품의 배송정보가 변경되었습니다. 상품을 다시 확인하시고 구매해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_OUTBOUND_LOCATION: 'FAILED_CHECK_PRODUCT_STOCK_OUTBOUND_LOCATION',
    /** 상품 정보가 유효하지 않습니다. 상품 정보를 다시 확인해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_NOT_FOUND: 'FAILED_CHECK_PRODUCT_STOCK_NOT_FOUND',
    /** 구매 불가 상품 - 배송정보 변경 */
    FAIL_OUTBOUND_LOCATION: 'FAIL_OUTBOUND_LOCATION',
    /** 구매 불가 상품 - 배송정보 변경 */
    DELIVERY_COMPANY_CHANGE: 'DELIVERY_COMPANY_CHANGE',
    /** 해당 네이버도착보장 상품의 여러 옵션 상품을 한번에 구매할 수 없습니다. */
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_BUNDLE_GROUP_BY_OPTION:
        'FAILED_CHECK_PRODUCT_STOCK_DELIVERY_BUNDLE_GROUP_BY_OPTION',
    /** 현재 해당 상품을 구매할 수 없습니다. 상품 정보를 다시 확인해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_DELIVERY_PLAN: 'FAILED_CHECK_PRODUCT_STOCK_DELIVERY_PLAN',
    /** 현재 해당 상품을 구매할 수 없습니다. 상품 정보를 다시 확인해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_ERROR: 'FAILED_CHECK_PRODUCT_STOCK_ERROR',
    /** 현재 해당 상품을 구매할 수 없습니다. 상품 정보를 다시 확인해주세요. */
    FAILED_CHECK_PRODUCT_STOCK_PRICE: 'FAILED_CHECK_PRODUCT_STOCK_PRICE',
    /** 재고가 부족하여 결제가 불가합니다. */
    FAILED_CHECK_PRODUCT_STOCK_QUANTITY: 'FAILED_CHECK_PRODUCT_STOCK_QUANTITY',
    /** 상품의 배송정보가 변경되었습니다. 상품을 다시 확인하시고 구매해주세요. */
    INVALID_CHECK_FULFILLMENT_PRODUCT_STOCK: 'INVALID_CHECK_FULFILLMENT_PRODUCT_STOCK',
    INVALID_PRODUCT_STATUS_ON_ORDER_SHEET_VIEW: 'INVALID_PRODUCT_STATUS_ON_ORDER_SHEET_VIEW',
    /** 라운지 가입 조회 과정에서 오류가 발생했습니다. 새로고침 후 재시도 해주세요. */
    UNKNOWN_LOUNGE_MEMBER: 'UNKNOWN_LOUNGE_MEMBER',
    /** 해당 상품은 라운지에 가입한 고객만 구매할 수 있습니다. */
    NOT_LOUNGE_MEMBER: 'NOT_LOUNGE_MEMBER',
    /** 관계법령에 따라 19세 이상 본인인증을 거쳐야 구매하실 수 있습니다. */
    IDENTITY_VERIFICATION_FAILED: 'IDENTITY_VERIFICATION_FAILED',
    /** 네이버페이 시스템 점검으로 서비스 이용이 불가합니다.\n점검 시간 이후 다시 이용해 주세요. */
    SMART_STORE_UNDER_MAINTENANCE: 'SMART_STORE_UNDER_MAINTENANCE',
    EXCEPTIONAL_CATEGORY_OVER_DISCOUNT_RATE: 'EXCEPTIONAL_CATEGORY_OVER_DISCOUNT_RATE',
    CONFLICT_DISCOUNT: 'CONFLICT_DISCOUNT',
    DISCOUNT_OVER_PAY_AMOUNT: 'DISCOUNT_OVER_PAY_AMOUNT',
    CARD_COMPANY_ID_EMPTY: 'CARD_COMPANY_ID_EMPTY',
    /** 카드사 프로모션 정보 조회에 실패했습니다 */
    CARD_PROMOTION_AGGREGATE_FAILED: 'CARD_PROMOTION_AGGREGATE_FAILED',
    CARD_PROMOTION_POLICY_PARTICIPATION_GET_FAILED: 'CARD_PROMOTION_POLICY_PARTICIPATION_GET_FAILED',
    CARD_PROMOTION_POLICY_CARD_DETAIL_EMPTY: 'CARD_PROMOTION_POLICY_CARD_DETAIL_EMPTY',
    CARD_PROMOTION_APPLY_TYPE_ERROR: 'CARD_PROMOTION_APPLY_TYPE_ERROR',
    CARD_PROMOTION_NOT_MATCHED_ORDER_SHEET_ITEM_ID: 'CARD_PROMOTION_NOT_MATCHED_ORDER_SHEET_ITEM_ID',
    INVALID_CARD_PROMOTION: 'INVALID_CARD_PROMOTION',
    INVALID_CARD_PROMOTION_DISCOUNT_AMOUNT: 'INVALID_CARD_PROMOTION_DISCOUNT_AMOUNT',
    INVALID_CARD_PROMOTION_STATE: 'INVALID_CARD_PROMOTION_STATE',
    /** 유효하지 않은 프로모션 (C2) */
    CARD_PROMOTION_VALIDATION_FAILED: 'CARD_PROMOTION_VALIDATION_FAILED',
    /** 유효하지 않은 프로모션 (C1) */
    POINT_PROMOTION_VALIDATION_FAILED: 'POINT_PROMOTION_VALIDATION_FAILED',
    CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_ADULT: 'CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_ADULT',
    CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_MINOR: 'CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_MINOR',
    CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_NO_ACCOUNT_REGISTRATION_HISTORY:
        'CARD_PROMOTION_APPLY_AMOUNT_EXCEED_LIMIT_NO_ACCOUNT_REGISTRATION_HISTORY',
    /** 카드사 프로모션 정보 조회에 실패했습니다 */
    CARD_PROMOTION_MEMBERSHIP_VALIDATION_FAILED: 'CARD_PROMOTION_MEMBERSHIP_VALIDATION_FAILED',
    /** 최대 선물 가능 인원수 초과 (최대 %s명) */
    AVAILABLE_GIFTING_FRIENDS_LIMIT: 'AVAILABLE_GIFTING_FRIENDS_LIMIT',
    /** 이쿠폰 상품과 실물상품은 동시에 선물하실 수 없습니다. */
    ECOUPON_AND_DELIVERY_TOGETHER_IN_CART_ORDER_GIFTING: 'ECOUPON_AND_DELIVERY_TOGETHER_IN_CART_ORDER_GIFTING',
    /** 컬리 - 상품 멀티딜 여부 검증 실패 */
    PRODUCT_MULTI_OPTION_TYPE: 'PRODUCT_MULTI_OPTION_TYPE',
    /** 컬리 - 배송유형 일정 검증 실패 */
    DELIVERY_SCHEDULE: 'DELIVERY_SCHEDULE',
    /** 컬리 - 판매불가 지역 */
    FAIL_RESTRICTED_AREA: 'FAIL_RESTRICTED_AREA',
} as const
